export default IconMapWest => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-map-west" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
  <path d="M9 9l1 6l2 -3.75l2 3.75l1 -6" />
</svg>`;